import Api from '@/services/Api'

export default {

  update (params) {
    return Api().put('users/' + params.id, params)
  },

  get (params) {
    return Api().get('posts/' + params.id)
  },

  login (params) {
      return Api().post('login/', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/UsersService.js